import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { cardSlides } from '../data/content';
export function CardCarousel() {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const slide = cardSlides[index];
  const go = (step: number) => {
    setDirection(step);
    setIndex(current => (current + step + cardSlides.length) % cardSlides.length);
  };
  return <div className="rounded-2xl border border-night-line bg-night-panel p-3 sm:p-5" role="group" aria-roledescription="carrusel" aria-label="Ejemplos de tarjetas del Botiquín Espiritual" data-id="element-32" data-mp="31hsn4c50ib35">
      <div className="relative overflow-hidden rounded-xl bg-parchment" data-id="element-33" data-mp="2rj32wcpn8ejq">
        <div className="aspect-[3/2] w-full" data-id="element-34" data-mp="1l3srhdd797lp">
          <AnimatePresence initial={false} mode="wait" data-id="element-35" data-mp="1l5n9ait6cjlk">
            <motion.img key={slide.image} src={slide.image} alt={`Tarjeta bíblica: ${slide.title}`} initial={{
            opacity: 0,
            x: direction * 24
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: direction * -24
          }} transition={{
            duration: 0.25,
            ease: [0.23, 1, 0.32, 1]
          }} className="h-full w-full object-contain" data-id="element-36" data-mp="1g4g48rif1yil" />
          </AnimatePresence>
        </div>

        <button type="button" onClick={() => go(-1)} aria-label="Tarjeta anterior" className="absolute left-2 top-1/2 -translate-y-1/2 rounded-full bg-night/85 p-2.5 text-parchment transition-colors duration-150 ease-out hover:bg-night focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-soft sm:left-3" data-id="element-37" data-mp="2fdiiinr7hj3b">
          <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-38" data-mp="1wewgn6nv7nyc" />
        </button>
        <button type="button" onClick={() => go(1)} aria-label="Tarjeta siguiente" className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full bg-night/85 p-2.5 text-parchment transition-colors duration-150 ease-out hover:bg-night focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-soft sm:right-3" data-id="element-39" data-mp="21dpuj072dgz1">
          <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-40" data-mp="13kgg02lkvdwx" />
        </button>
      </div>

      <div className="mt-4 flex flex-col items-center gap-3 px-1 sm:flex-row sm:justify-between" data-id="element-41" data-mp="217yqbhuw0o31">
        <div aria-live="polite" className="text-center sm:text-left" data-id="element-42" data-mp="1w8vpyapur61e">
          <p className="font-display text-lg font-semibold text-parchment" data-id="element-43" data-mp="1w6ssx6qa8cn6">{slide.title}</p>
          <p className="font-sans text-sm text-parchment/55" data-id="element-44" data-mp="1r7y15fac7dqx">{slide.need}</p>
        </div>

        <div className="flex items-center gap-2" data-id="element-45" data-mp="1ma682hxyhll5">
          {cardSlides.map((item, slideIndex) => <button key={item.image} type="button" onClick={() => {
          setDirection(slideIndex > index ? 1 : -1);
          setIndex(slideIndex);
        }} aria-label={`Ver la tarjeta ${item.title}`} aria-current={slideIndex === index} className={`h-2.5 rounded-full transition-[width,background-color] duration-150 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-soft ${slideIndex === index ? 'w-7 bg-gold-soft' : 'w-2.5 bg-night-line'}`} data-id="element-46" data-mp="fw6vr540iy7w" data-mpi={slideIndex} />)}
        </div>
      </div>
    </div>;
}